import { callGetExternalApi, callPostExternalApi } from '@ctn/axios-util';

import { type Evento } from '@/interfaces/model/eventos.interface';
import type { IErrorResponse } from '@/interfaces/model/fetch.interface';
import type { IEstadistica, ISolicitud, ISolicitudBorrador } from '@/interfaces/model/solicitudes.interface';
import { processError } from '@/utils/axiosErrors';
import axiosInstance from '@/utils/axiosInterceptor';

type ISolicitudParams = {
	nifEmisor?: ISolicitud['emisor']['nif'];
	idTipoSector?: ISolicitud['emisor']['tipoSector']['id'];
	idTipoTramite?: ISolicitud['tipoTramite']['id'];
	id?: ISolicitud['id'];
};

export type IEstadisticasSolicitud = {
	total: number;
	listaEstadisticaTipoEstadoSolicitud: IEstadistica[];
};

export type ISolicitudResponse = {
	listado: ISolicitud[];
	totalResults: number;
};

export type ISolicitudEliminacionPayload = {
	nifEmisor: ISolicitud['emisor']['nif'];
	idTipoSector: ISolicitud['emisor']['tipoSector']['id'];
	idTipoTramite: ISolicitud['tipoTramite']['id'];
	id: ISolicitud['id'];
};

export type ISolicitudListadoPayload = {
	limit: number;
	start: number;
	numeroTramiteExterno?: string;
	listaIdsEstadoSolicitud?: number[];
	listaIdsTipoTramite?: number[];
	listaIdsSubtipoTramite?: number[];
	fechaDesde?: string;
	fechaHasta?: string;
};

export type ISolicitudDetallePayload = {
	nifEmisor: string;
	idTipoSector: number;
	id: number;
};

export type ISolicitudHistorialPayload = {
	nifEmisor: string;
	idTipoSector: number;
	id: number;
};

const getBackendUrlSolicitudes = ({ nifEmisor, idTipoSector, idTipoTramite, id }: ISolicitudParams) => ({
	POST_SOLICITUD_ELIMINACION: `/solicitudes/eliminacion/${nifEmisor}/${idTipoSector}/${idTipoTramite}/${id}`,
	POST_SOLICITUD_DETALLE: `/solicitudes/detalle/${nifEmisor}/${idTipoSector}/${id}`,
	POST_SOLICITUD_ESTADISTICAS: '/solicitudes/estadisticas',
	GET_SOLICITUD_HISTORIAL: `/solicitudes/historial/${nifEmisor}/${idTipoSector}/${id}`,
	POST_SOLICITUD_LISTADO: '/solicitudes/listado',
});

const postSolicitudEliminacion = async (data: ISolicitudEliminacionPayload) =>
	callPostExternalApi<undefined>({
		axiosInstance,
		withCredentials: true,
		url: getBackendUrlSolicitudes(data).POST_SOLICITUD_ELIMINACION,
		processError
	});

const getSolicitudDetalle = async (data: ISolicitudDetallePayload) =>
	callGetExternalApi<ISolicitudBorrador>({
		axiosInstance,
		withCredentials: true,
		url: getBackendUrlSolicitudes(data).POST_SOLICITUD_DETALLE,
		data,
		processError,
	});

const getSolicitudEstadisticas = async () =>
	callGetExternalApi<IEstadisticasSolicitud>({
		axiosInstance,
		withCredentials: true,
		url: getBackendUrlSolicitudes({}).POST_SOLICITUD_ESTADISTICAS,
		processError
	});

const getSolicitudHistorial = async (data: ISolicitudHistorialPayload) =>
	callGetExternalApi<Evento[] | IErrorResponse>({
		axiosInstance,
		withCredentials: true,
		url: getBackendUrlSolicitudes(data).GET_SOLICITUD_HISTORIAL,
		processError
	});

const postSolicitudListado = async (data: ISolicitudListadoPayload) =>
	callPostExternalApi<ISolicitudResponse | IErrorResponse>({
		axiosInstance,
		withCredentials: true,
		url: getBackendUrlSolicitudes({}).POST_SOLICITUD_LISTADO,
		data,
		processError
	});

export {
	getSolicitudDetalle,
	getSolicitudEstadisticas,
	getSolicitudHistorial,
	postSolicitudEliminacion,
	postSolicitudListado
};

